(ns minorodata.app.subs
  (:require
   [applied-science.js-interop :as jsi]
   [clojure.tools.reader.edn :as edn]
   [minorodata.app.handlers :refer [reg-cofx]]
   [minorodata.app.utils :refer [try-parse-features]]
   [minorodata.connections.subs]
   [minorodata.dag.subs]
   [minorodata.dependency-graph.subs]
   [minorodata.statuses.subs]
   [minorodata.data-views.subs]
   [minorodata.file-ingest.subs]
   [minorodata.global-search.subs]
   [minorodata.group.subs]
   [minorodata.health.subs]
   [minorodata.ingest.subs]
   [minorodata.localforage.subs]
   [minorodata.logs.subs]
   [minorodata.notifications.subs]
   [minorodata.recipes.subs]
   [minorodata.sandbox.subs]
   [minorodata.sql-console-modal.subs]
   [minorodata.sql-console.subs]
   [minorodata.tables-metadata.subs]
   [minorodata.transform-environments.subs]
   [minorodata.transform.subs]
   [minorodata.transformations.subs]
   [minorodata.unleash.subs]
   [minorodata.users.subs]
   [minorodata.webhooks.subs]
   [minorodata.analytics.subs]
   [minorodata.ai-chat.subs]
   [minorodata.analytics-models.subs]
   [minorodata.warehouse-usage.subs]
   [minorodata.usage-account.subs]
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]))


(reg-cofx
 :get-local-storage
 (fn [coeffects [local-storage-key default]]
   (let [default      (or default nil)
         stored-value (js/localStorage.getItem local-storage-key)
         parsed-value (if (some? stored-value)
                        (js/JSON.parse stored-value)
                        default)]
     (assoc-in coeffects [:local-storage local-storage-key] parsed-value))))


(reg-cofx
 :get-local-storage-edn
 (fn [coeffects [local-storage-key default]]
   (let [default      (or default nil)
         stored-value (js/localStorage.getItem local-storage-key)
         parsed-value (if (some? stored-value)
                        (edn/read-string stored-value)
                        default)]
     (assoc-in coeffects [:local-storage local-storage-key] parsed-value))))


(reg-cofx
 :get-local-storage-raw
 (fn [coeffects [local-storage-key]]
   (let [stored-value (js/localStorage.getItem local-storage-key)]
     (assoc-in coeffects [:local-storage local-storage-key] stored-value))))


(re-frame/reg-sub
 :app.subs/get-local-storage
 (fn [_ [_ local-storage-key default]]
   (let [default      (or default nil)
         stored-value (js/localStorage.getItem local-storage-key)]

     (if (some? stored-value)
       (js/JSON.parse stored-value)
       default))))


(re-frame/reg-sub
 :app.subs/get-local-storage-raw
 (fn [_ [_ local-storage-key]]
   (js/localStorage.getItem local-storage-key)))


(re-frame/reg-sub
 :app.subs/render-error
 (fn [db _]
   (get-in db [:app/error :render])))


(re-frame/reg-sub
 :app.subs/app-ready?
 (fn []
   (re-frame/subscribe [:app/pull]))
 (fn [app]
   (or (:app/ready? app) false)))

(re-frame/reg-sub
 :app.subs/timezone
 (fn []
   (let [client-id @(re-posh/subscribe [:user/prop :user/cid])
         timezone  @(re-posh/subscribe [:client-data/prop [:client-data/cid client-id] :client-data/timezone])]
     timezone)))


(re-frame/reg-sub
 :app.subs/enabled-for-bigquery
 :<- [:unleash/is-enabled "enabled-for-bigquery"]
 :<- [:unleash/get-variant "enabled-for-bigquery"]
 (fn [[enabled? variant] [_ feature]]
   (if (and (not enabled?) (= (:name variant) "disabled"))
     ;; user isn't using BigQuery as a WH so showing all features
     true
     ;; checking enabled features
     (let [features (try-parse-features variant)]
       (-> (jsi/get features feature)
           boolean)))))


(re-frame/reg-sub
 :modals.subs/modal-open?
 (fn [db [_ modal-id]]
   (get-in db [:app/modals modal-id :open?])))

(re-frame/reg-sub
 :modals.subs/modal-params
 (fn [db [_ modal-id]]
   (get-in db [:app/modals modal-id :params])))

(re-frame/reg-sub
 :app.subs/new-page-labels
 :<- [:unleash/get-variant "fe.new-page-labels"]
 (fn [variant]
   (some->> (js->clj (try-parse-features variant) :keywordize-keys true)
            (mapv keyword))))
